/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".no-border[_ngcontent-%COMP%]{border:0}.mp-0[_ngcontent-%COMP%]{margin:0!important;padding:0!important}.mt-10[_ngcontent-%COMP%]{margin-top:10px!important}.close[_ngcontent-%COMP%]{margin-top:0!important}\n/*# sourceMappingURL=support-modal.component.css.map*/"];
export { styles as styles };
